// extracted by mini-css-extract-plugin
module.exports = {"addWrap":"Groups_addWrap__3kUrL","addNew__icon":"Groups_addNew__icon__2KIvN","addNew__text":"Groups_addNew__text__3O9zd","goBack__icon":"Groups_goBack__icon__2sNK-"};